import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#008080] to-[#483D8B] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        
        {/* Top Section: Logo + Links Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          
          {/* Brand Section - Left */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/rarifex-logo.png" 
                alt="Rarifex Logo"
                className="h-12 w-auto object-contain"
              />
              <div>
                <span className="font-black text-xl tracking-tight">RARIFEX</span>
                <p className="text-xs text-white/90 mt-1 font-medium">L'arte di essere unici.</p>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Il marketplace italiano dedicato alle creazioni artigianali uniche. Ogni pezzo racconta una storia.
            </p>
            
            {/* Social Icons */}
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all hover:scale-110">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all hover:scale-110">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all hover:scale-110">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="mailto:info@rarifex.com" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all hover:scale-110">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Links Sections - Right (5 columns) */}
          <div className="lg:col-span-9">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-4">
              
              {/* Scopri */}
              <div>
                <h4 className="font-bold mb-3 text-white text-sm">Scopri</h4>
                <ul className="space-y-2">
                  <li><Link to="/esplora" className="text-white/70 hover:text-white transition-colors text-sm">Prodotti Artigianali</Link></li>
                  <li><Link to="/regalo-personalizzato" className="text-white/70 hover:text-white transition-colors text-sm">Regali Personalizzati</Link></li>
                  <li><Link to="/crafters" className="text-white/70 hover:text-white transition-colors text-sm">Artigiani</Link></li>
                  <li><Link to="/categorie" className="text-white/70 hover:text-white transition-colors text-sm">Categorie</Link></li>
                  <li><Link to="/manifesto" className="text-white/70 hover:text-white transition-colors text-sm">Manifesto</Link></li>
                </ul>
              </div>

              {/* Per i Clienti */}
              <div>
                <h4 className="font-bold mb-3 text-white text-sm">Per i Clienti</h4>
                <ul className="space-y-2">
                  <li><Link to="/come-acquistare" className="text-white/70 hover:text-white transition-colors text-sm">Come Acquistare</Link></li>
                  <li><Link to="/prodotto-su-misura" className="text-white/70 hover:text-white transition-colors text-sm">Prodotto su misura</Link></li>
                  <li><Link to="/pagamenti" className="text-white/70 hover:text-white transition-colors text-sm">Pagamenti</Link></li>
                  <li><Link to="/spedizioni" className="text-white/70 hover:text-white transition-colors text-sm">Spedizioni</Link></li>
                  <li><Link to="/resi-rimborsi" className="text-white/70 hover:text-white transition-colors text-sm">Resi e Rimborsi</Link></li>
                </ul>
              </div>

              {/* Per gli Artigiani */}
              <div>
                <h4 className="font-bold mb-3 text-white text-sm">Per gli Artigiani</h4>
                <ul className="space-y-2">
                  <li><Link to="/plans" className="text-white/70 hover:text-white transition-colors text-sm">Diventa Artigiano</Link></li>
                  <li><Link to="/come-vendere" className="text-white/70 hover:text-white transition-colors text-sm">Come vendere</Link></li>
                  <li><Link to="/commissioni" className="text-white/70 hover:text-white transition-colors text-sm">Commissioni</Link></li>
                  <li><Link to="/plans" className="text-white/70 hover:text-white transition-colors text-sm">Piani Premium</Link></li>
                  <li><Link to="/linee-guida" className="text-white/70 hover:text-white transition-colors text-sm">Linee Guida</Link></li>
                </ul>
              </div>

              {/* Azienda e Supporto */}
              <div>
                <h4 className="font-bold mb-3 text-white text-sm">Supporto</h4>
                <ul className="space-y-2">
                  <li><Link to="/come-funziona" className="text-white/70 hover:text-white transition-colors text-sm">Come Funziona</Link></li>
                  <li><Link to="/chi-siamo" className="text-white/70 hover:text-white transition-colors text-sm">Chi Siamo</Link></li>
                  <li><Link to="/contatti" className="text-white/70 hover:text-white transition-colors text-sm">Contatti</Link></li>
                  <li><Link to="/assistenza" className="text-white/70 hover:text-white transition-colors text-sm">Centro Assistenza</Link></li>
                  <li><Link to="/faq" className="text-white/70 hover:text-white transition-colors text-sm">FAQ</Link></li>
                </ul>
              </div>

              {/* Legale */}
              <div>
                <h4 className="font-bold mb-3 text-white text-sm">Legale</h4>
                <ul className="space-y-2">
                  <li><Link to="/termini" className="text-white/70 hover:text-white transition-colors text-sm">Termini e Condizioni</Link></li>
                  <li><Link to="/privacy" className="text-white/70 hover:text-white transition-colors text-sm">Privacy Policy</Link></li>
                  <li><Link to="/cookie" className="text-white/70 hover:text-white transition-colors text-sm">Cookie Policy</Link></li>
                  <li><Link to="/resi-rimborsi" className="text-white/70 hover:text-white transition-colors text-sm">Diritto di Recesso</Link></li>
                  <li><Link to="/controversie" className="text-white/70 hover:text-white transition-colors text-sm">Controversie</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-10 pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-xs">
              &copy; {currentYear} Rarifex. Creato artigianalmente con passione in Italia.
            </p>
            <div className="flex items-center gap-2 text-white/60 text-xs">
              <MapPin className="w-3 h-3" />
              <span>Milano, Italia</span>
              <span className="mx-2">•</span>
              <a href="mailto:info@rarifex.com" className="hover:text-white transition-colors">info@rarifex.com</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
